import * as config from "../config.js";

export const saveAgent = async (agent, clientId) => {
  const method = agent.id ? "PUT" : "POST";
  agent.workflow_graph = typeof agent.workflow_graph === "object" ? JSON.stringify(agent.workflow_graph) : agent.workflow_graph;
  const url = agent.id ? `${config.REST_SERVER_URL}/admin/agent/${agent.public_id}` : `${config.REST_SERVER_URL}/admin/agent`;
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      ...agent,
      client_id: clientId,
    }),
  });

  const results = await response.json();
  return results;
}

export const getAgent = async (agentId) => {
  const url = `${config.REST_SERVER_URL}/admin/agent/${agentId}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  });

  const results = await response.json();
  return results;
}

export const runAgentWorkflowGraph = async (public_id, input, context) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = `${config.REST_SERVER_URL}/admin/agent/run-workflow-graph/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({ input, context }),
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const results = await response.json();
  return results;
}

export const startChatSession = async (agent_id, inference_workflow_id = null, context = {}) => {
  context = typeof context === "object" ? context : JSON.parse(context);
  const response = await fetch(`${config.REST_SERVER_URL}/admin/chat/start/${agent_id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      inference_workflow_id: inference_workflow_id,
      context: context,
    }),
  })

  const results = await response.json();
  return results;
};

export const getChatSessions = async (agent_id) => {
  const url = `${config.REST_SERVER_URL}/admin/agent/${agent_id}/chats`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  });

  const results = await response.json();
  return results;
};

export const getChatSession = async (chat_session_id) => {
  const response = await fetch(`${config.REST_SERVER_URL}/admin/chat/session/${chat_session_id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  });

  const results = await response.json();
  return results;
};


export const sendChatMessage = async (
  message,
  chat_session_id,
  skip_user_message = false,
  return_context = false,
) => {
  console.log("SEND MESSAGE: ", message, chat_session_id);
  const response = await fetch(`${config.REST_SERVER_URL}/admin/chat/message/${chat_session_id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify({
      message: message,
      skip_user_message: skip_user_message,
      return_context: return_context,
    }),
  });

  const results = await response.json();
  return results;
};


export const getAvailableModels = async () => {
  const url = `${config.REST_SERVER_URL}/admin/agent/available-models`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  });

  const results = await response.json();
  return results;
};
